import { useState, memo } from "react";
import { useForm } from "react-hook-form";
import { IconButton, Modal, Button } from "../../../../shared/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { VacancyOfferFormSchema, offerForm } from "../../consts";
import {
    VacancyControlInputText,
    VacancyControlInputPhone,
    VacancyControlInputFile,
    VacancyControlInputCheckbox,
} from "../VacancyControlInput";

import type { IVacancyOfferForm } from "../../types";

import styles from "./VacancyOfferForm.module.scss";
import { generateMediaQuery } from "../../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";
import { useSendFormApplyResumeOnBcsMutation } from "../../api/applicantFormApi";

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.md);

export const VacancyOfferForm = memo(() => {
    const isMobile = useMediaQuery(mediaQuery);

    const [isFill, setIsFill] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const [sendFormApplyResumeOnBcs, { isLoading: isLoadingForm }] = useSendFormApplyResumeOnBcsMutation();

    const {
        control,
        getValues,
        handleSubmit: onSubmit,
        reset,
    } = useForm<IVacancyOfferForm>({
        defaultValues: offerForm,
        resolver: yupResolver(VacancyOfferFormSchema),
    });

    const handleOpen = () => setIsOpen(true);

    const handleClose = () => setIsOpen(false);

    const handleSubmit = async (values: IVacancyOfferForm) => {
        try {
            await sendFormApplyResumeOnBcs(values).unwrap();
            reset();
            handleClose();
        } catch (error: unknown) {
            console.error(error);
        }
    };

    const props = {
        control,
        onChangeFill: () => setIsFill(Object.values(getValues()).every(Boolean)),
    };

    return (
        <>
            <button className={styles.button} onClick={handleOpen}>
                Напишите&nbsp;нам
            </button>
            <Modal isOpen={isOpen}>
                <section className={styles.modal}>
                    {isMobile ? (
                        <>
                            <button onClick={handleClose} className={styles.backButton}></button>
                            <button onClick={handleClose} className={styles.burger}></button>
                        </>
                    ) : (
                        <IconButton icon="close" theme="white" onClick={handleClose} className={styles.close} />
                    )}
                    <h2 className={styles.title}>Присылайте ваше резюме</h2>
                    <form className={styles.form} onSubmit={onSubmit(handleSubmit)}>
                        <VacancyControlInputText name="name" placeholder="Фамилия и имя" {...props} />
                        <div className={styles.line}>
                            <VacancyControlInputText name="email" placeholder="Email" {...props} />
                            <VacancyControlInputPhone name="phone" {...props} />
                        </div>
                        <VacancyControlInputFile name="resume" {...props} className={styles.upload} />
                        <VacancyControlInputCheckbox name="personalData" {...props} />
                        <Button
                            as="button"
                            type="submit"
                            className={styles.offerButton}
                            isDisabled={!isFill}
                            size="s"
                            loading={isLoadingForm}
                        >
                            Предложить
                        </Button>
                    </form>
                </section>
            </Modal>
        </>
    );
});

VacancyOfferForm.displayName = "VacancyOfferForm";
